import { IPerfilFinanceiro } from "../../../../Interfaces/Geral/GestaoDeCadastro/PerfilFinanceiro/PerfilFinanceiroInterface";
import {
    AtualizarPerfilFinanceiroService,
    CadastrarPerfilFinanceiroService,
    DeletarPerfilFinanceiroService,
    GetPerfilFinanceiroService,
    ListarPerfilFinanceiroService,
} from "../../../../Services/Geral/PerfilFinanceiro/PerfilFinanceiroServices";
import { Controller } from "../../../Controller";

export async function ListarPerfilFinanceiroController() {
    return Controller(ListarPerfilFinanceiroService());
}

export async function GetPerfilFinanceiroController(
    idPerfilFinanceiroConta: number
) {
    return Controller(GetPerfilFinanceiroService(idPerfilFinanceiroConta));
}

export async function CadastrarPerfilFinanceiroController(
    data: IPerfilFinanceiro
) {
    return Controller(CadastrarPerfilFinanceiroService(data));
}

export async function AtualizarPerfilFinanceiroController(
    data: IPerfilFinanceiro
) {
    return Controller(AtualizarPerfilFinanceiroService(data));
}
export async function DeletarPerfilFinanceiroController(
    idPerfilFinanceiroConta: number
) {
    return Controller(DeletarPerfilFinanceiroService(idPerfilFinanceiroConta));
}
